/**
 * Second-factor methods returned by `POST /auth/login` (FR-04). The second
 * factor is method-agnostic by design: the login response names the method in
 * use and the client renders from it, so adding a delivery-less factor is a
 * new branch rather than a rewrite (`docs/specs/features/identity-access/02-design.md` §11 decision 4).
 */
export const TWO_FACTOR_METHODS = {
  /** Backend-generated 6-digit code emailed to the account address. */
  EMAIL_OTP: 'email_otp',
  /** Authenticator-app code. No delivery step, so nothing to resend. */
  TOTP: 'totp',
} as const;

export type TwoFactorMethod = (typeof TWO_FACTOR_METHODS)[keyof typeof TWO_FACTOR_METHODS];
